import { getBrowser } from '@/helpers/getBrowser'
import ABTests from '@/helpers/ABTests'

export default {
  data() {
    return {
      nameSelectedSection: '',
      email: '',
      browser: '',
      isAutotest: false,
      isABTestEnabled: false,
      abFormVariant: '0',
      abFilterVariant: '0',
    }
  },
  mounted() {
    this.browser = getBrowser().toLowerCase()

    if (this.$route.query.autotest === '1') {
      this.isAutotest = true
    } else {
      // ab-tests goes here:
      this.abFormVariant = ABTests.getABFormSelectorVariant(
        'ab_meetings_form_variant'
      )
      this.abFilterVariant = ABTests.getABFormSelectorVariant(
        'ab_meetings_filter'
      )
      this.isABTestEnabled = ABTests.isABTestEnabled()
    }

    // при наличии этих значений в адресе отправляем на формы регистрации
    if (
      [
        '#form',
        '#form-webinar',
        '#form-meetings',
        '#form-participant',
      ].includes(location.hash)
    ) {
      location.href = '/user/'
    }
  },
  methods: {
    handlerSelectedSection(nameSelectedSection) {
      switch (nameSelectedSection) {
        case 'communication':
          this.nameSelectedSection = 'Коммуникации'
          break
        case 'education':
          this.nameSelectedSection = 'Обучение'
          break
      }
    },
  },
}
